"use client";

import React from "react";
import { TrendingUp, Users, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefitsData = [{
  icon: TrendingUp,
  title: "BKE-Gecertificeerd",
  description: "Al onze assessoren en beoordelaars beschikken over de juiste kwalificaties voor betrouwbare en valide examinering binnen het HBO."
}, {
  icon: Users,
  title: "Management Support",
  description: "Wij ontzorgen onderwijsmanagers door op te treden als strategische partner en one-stop-shop voor alle externe onderwijsexpertise."
}, {
  icon: Zap,
  title: "Capaciteitsborging",
  description: "Snel en flexibel schakelen bij piekmomenten of uitval, met professionals die direct inzetbaar zijn binnen uw specifieke curriculum."
}];
export default function Benefits() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="132916" id="voor-onderwijsinstellingen" className="bg-background py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`mx-auto max-w-2xl text-center transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="mt-2 text-4xl font-default font-bold tracking-tight text-primary sm:text-5xl">
            De partner voor de inzet van externe assessoren en beoordelaars
          </p>
          <p className="mt-6 text-lg/8 text-muted-foreground font-sans text-center">
            EduMedius biedt een integrale oplossing voor complexe capaciteitsvraagstukken. Wij borgen de continuïteit van uw onderwijs met ervaren professionals.
          </p>
        </div>

        <div ref={gridRef} className={`mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {benefitsData.map((benefit, i) => {
            const Icon = benefit.icon;
            return <div key={benefit.title} data-index={i} className="group flex flex-col items-center text-center">
                  <div className="mb-6 flex size-16 items-center justify-center rounded-2xl bg-chart-2/10 text-chart-2 transition-all duration-500 ease-out group-hover:bg-chart-2/20 group-hover:shadow-lg group-hover:scale-110">
                    <Icon className="size-8" aria-hidden="true" strokeWidth={1.5} />
                  </div>
                  <div className="transition-transform duration-500 ease-out group-hover:-translate-y-2">
                    <h3 className="text-xl font-default font-semibold leading-7 text-primary">
                      {benefit.title}
                    </h3>
                    <p className="mt-4 text-base leading-7 text-muted-foreground font-sans">
                      {benefit.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}